// extracted by mini-css-extract-plugin
export default {"root":"ColorInput_root__TL3Ya"};